import {} from "react-admin";
import { Button, Divider, Grid, Stack, Tooltip, Typography } from "@mui/material";
import { CargoList } from "./components/cargo-list";
import { DriverSchedulingList } from "./components/drivers-scheduling/driver-scheduling-list";
import CargoContext from "../contexts/CargoContext";
import React from "react";
import { FleetMatchingDrivers } from "./fleets/fleets/fleet-matching-drivers";
import UserContext from "../contexts/UserContext";
import { useNavigate } from "react-router-dom";
import { Cargo } from "../models/Cargo";

const MAP_DRIVER_DISABLED_TOOLTIP = "当前货源缺少始发地坐标，无法打开地图司机";

const getMapNavigationPayload = (cargo: Cargo | null | undefined) => {
  const coordinates = cargo?.from?.location?.coordinates;
  const longitude = cargo?.from?.longitude;
  const latitude = cargo?.from?.latitude;

  const lon =
    Array.isArray(coordinates) && coordinates.length >= 2
      ? coordinates[0]
      : longitude;
  const lat =
    Array.isArray(coordinates) && coordinates.length >= 2
      ? coordinates[1]
      : latitude;

  if (typeof lat !== "number" || typeof lon !== "number") {
    return null;
  }

  const address = [
    cargo?.from?.province,
    cargo?.from?.city,
    cargo?.from?.district,
    cargo?.from?.address,
  ]
    .filter(Boolean)
    .join("");

  return {
    lat,
    lon,
    address,
  };
};

export const Scheduling = () => {
  const { selectedCargo: rawSelectedCargo } = React.useContext(CargoContext);
  const { isScheduler } = React.useContext(UserContext);
  const navigate = useNavigate();
  const selectedCargo = React.useMemo(() => rawSelectedCargo, [rawSelectedCargo]);
  const mapNavigationPayload = React.useMemo(
    () => getMapNavigationPayload(selectedCargo),
    [selectedCargo]
  );

  const handleGoToMapDrivers = React.useCallback(() => {
    if (!mapNavigationPayload) {
      return;
    }

    const searchParams = new URLSearchParams({
      lat: String(mapNavigationPayload.lat),
      lon: String(mapNavigationPayload.lon),
      address: mapNavigationPayload.address,
      distance: "50",
    });

    navigate(`/map/map_drivers?${searchParams.toString()}`);
  }, [mapNavigationPayload, navigate]);

  return (
    <Grid container spacing={3}>
      <Grid
        item
        xs={12}
        md={isScheduler ? 6 : 12}
        style={{ maxHeight: "96vh", overflowY: "auto" }}
      >
        <Typography>有效货物</Typography>
        <CargoList />
      </Grid>
      {isScheduler && (
        <Grid item xs={12} md={6}>
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
            justifyContent="space-between"
            sx={{ mb: 1 }}
          >
            <Typography>匹配司机（仅App）</Typography>
            <Tooltip
              title={mapNavigationPayload ? "" : MAP_DRIVER_DISABLED_TOOLTIP}
              arrow
            >
              <span>
                <Button
                  variant="contained"
                  onClick={handleGoToMapDrivers}
                  disabled={!mapNavigationPayload}
                >
                  地图司机
                </Button>
              </span>
            </Tooltip>
          </Stack>
          {selectedCargo && (
            <DriverSchedulingList selectedCargo={selectedCargo} />
          )}
          <Divider style={{ margin: "20px 0" }} />
          <Typography>匹配车队司机（多渠道）</Typography>
          {selectedCargo && (
            <FleetMatchingDrivers selectedCargo={selectedCargo} />
          )}
        </Grid>
      )}
    </Grid>
  );
};
